import { Card } from "@twilio-paste/core/card";
import { Box } from "@twilio-paste/core/box";
import { Stack } from "@twilio-paste/core/stack";
import { SkeletonLoader } from "@twilio-paste/core/skeleton-loader";
import PromptLibrarySuggestions from "./sub/PromptLibrarySuggestions";
import PromptLibraryEmptyState from "./sub/PromptLibraryEmptyState";

import { usePromptContext } from "@twiliointernal/e2-commons-shared-hooks";
import { PromptLibraryContainerProps } from "./definitions";
import { useEffect, useRef } from "react";

const PromptLibraryContainer = ({
  handlePromptSuggestionSelected,
  onChatButtonToolClick,
  setOpenPromptLibrary,
  isChatActive,
}: PromptLibraryContainerProps) => {
  const promptLibraryRef = useRef<HTMLDivElement | null>(null);

  const { userPromptList, userHasPrompts } = usePromptContext();

  // Hack to mimic the behavior of the onBlur event when the user clicks outside of the prompt library
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event: MouseEvent) => {
    if (
      promptLibraryRef.current &&
      !promptLibraryRef.current.contains(event.target as Node)
    ) {
      setOpenPromptLibrary(false);
    }
  };

  return (
    <Box
      ref={promptLibraryRef}
      as="section"
      borderColor="colorBorderWeaker"
      borderRadius="borderRadius30"
      borderStyle="solid"
      borderWidth="borderWidth10"
      boxShadow="shadowCard"
      position="absolute"
      top={isChatActive ? undefined : "100%"}
      bottom={isChatActive ? "100%" : undefined}
      width="100%"
      backgroundColor="colorBackgroundBody"
      zIndex="zIndex10"
    >
      {userPromptList &&
        userPromptList.map((prompt) => (
          <PromptLibrarySuggestions
            key={prompt.id}
            prompt={prompt}
            handlePromptSuggestionSelected={handlePromptSuggestionSelected}
          />
        ))}
      {!userHasPrompts && userPromptList && userPromptList.length === 0 && (
        <PromptLibraryEmptyState
          handleChatButtonToolClick={onChatButtonToolClick}
          handleClosePromptLibrary={setOpenPromptLibrary}
        />
      )}
      {!userPromptList && (
        <Card>
          <Stack orientation="vertical" spacing="space60">
            <SkeletonLoader />
            <SkeletonLoader />
            <SkeletonLoader />
          </Stack>
        </Card>
      )}
    </Box>
  );
};

export default PromptLibraryContainer;
